<template>
    <v-data-table
        :single-select="false"
        item-key="order_id"
        :show-select="showSelect"
        :headers="headers"
        :items="screens"
        :items-per-page="10"
        :loading="loading"
        loading-text="Loading ... please wait"
        :loader-height="6"
        hide-default-footer
        disable-pagination
        @toggle-select-all="$emit('toggle-select-all', $event)"
        @item-selected="$emit('item-selected', $event)"
    >
        <template v-slot:item.status.label="{ item }">
            <v-chip
                v-if="!processing($_.get(item, 'status.status'))"
                small
                :color="$_.get(item, 'status.color', '')"
                v-text="$_.get(item, 'status.label', '')"
            ></v-chip>
            <v-progress-linear
                indeterminate
                rounded
                height="8"
                v-else
            ></v-progress-linear>
        </template>
        <template v-slot:item.applicant="{ item }">
            <div class="d-flex flex-column my-1">
                <span
                    class="font-weight-medium alternate1--text text--darken-1"
                    >{{ item.applicant.name }}</span
                >
                <div>
                    <span class="font-weight-light">Type:</span>
                    <span class="font-weight-medium ml-1">{{
                        item.applicant.type
                    }}</span>
                </div>
            </div>
        </template>
        <template v-slot:item.order_id="{ item }">
            <router-link
                v-if="editEnabled($_.get(item, 'status.status'))"
                :to="{
                    name: 'Application Process',
                    params: { id: item.order_id },
                }"
                >{{ item.order_id }}
            </router-link>
            <span v-else>{{ item.order_id }}</span>

            <psi-copy-button
                :value="item.order_id"
                label="Order ID"
            ></psi-copy-button>
            <v-chip
                v-if="item.item_new"
                color="success darken-2"
                small
                class="pa-1 ml-1 text-caption"
                >new</v-chip
            >
        </template>
        <template v-slot:item.code="{ item }">
            <router-link
                v-if="editEnabled($_.get(item, 'status.status'))"
                :to="{
                    name: 'View Application',
                    params: { id: item.code },
                }"
                >{{ item.code }}</router-link
            >
            <span v-else>{{ item.code }}</span>

            <psi-copy-button
                :value="item.code"
                label="Application Code"
            ></psi-copy-button>
        </template>

        <template v-slot:item.property="{ item }">
            <div class="d-flex flex-column my-1">
                <span class="font-weight-medium alternate1--text text--darken-1"
                    >{{ item.property.name }} | {{ item.unit }}
                </span>
                <div>
                    <span>{{ $_.get(item, "property.company.name", "") }}</span>
                </div>
            </div>
        </template>
        <template v-slot:item.created_at="{ item }">
            <div class="d-flex flex-column my-3">
                <span
                    class="font-weight-medium alternate1--text text--darken-1"
                    >{{ item.created_at }}</span
                >
                <div
                    v-if="
                        $_.get(item, 'status.label', '') !=
                            'Screen Completed' && item.time_pending !== null
                    "
                >
                    <span>
                        <v-chip small class="text-caption" color="primary ">{{
                            item.time_pending
                        }}</v-chip>
                    </span>
                </div>
            </div>
        </template>
        <template v-slot:item.assigned_to="{ item }">
            <order-assigned-to
                v-if="editEnabled($_.get(item, 'status.status'))"
                :screeners="screeners"
                :assigned_to="item.assigned_to"
                @update:assignedTo="updateAssigned(item.order_id, $event)"
            ></order-assigned-to>
        </template>
        <template v-slot:item.actions="{ item }">
            <psi-action-drop-down
                :disabled="actionDisabled($_.get(item, 'status.status'))"
                :heading="`Actions - ${$_.get(item, 'applicant.name')}`"
                :items="getActions(item)"
                @action="$emit('action', item, $event)"
            ></psi-action-drop-down>
        </template>
    </v-data-table>
</template>
<script>
import lib from "../library";
import { mapActions } from "vuex";

export default {
    name: "screening-list",
    components: {
        OrderAssignedTo: () => import("./Order/OrderAssignedTo"),
    },
    props: {
        screens: {
            type: Array,
            required: true,
        },
        screeners: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        },
        showSelect: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    data() {
        return {
            actions: [
                {
                    title: "View Screen",
                    icon: "mdi-clipboard-account",
                },
                {
                    title: "View Screen",
                    icon: "mdi-clipboard-account",
                },
            ],
            headers: [
                {
                    text: "Order ID",
                    align: "start",
                    sortable: true,
                    value: "order_id",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Start Date",
                    align: "start",
                    sortable: true,
                    value: "created_at",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Status",
                    align: "start",
                    sortable: true,
                    value: "status.label",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Source",
                    align: "start",
                    sortable: true,
                    value: "source",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Applicant",
                    align: "start",
                    sortable: false,
                    value: "applicant",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Group Code",
                    align: "start",
                    sortable: true,
                    value: "code",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Property / Unit",
                    align: "start",
                    sortable: false,
                    value: "property",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Assigned To",
                    align: "start",
                    sortable: true,
                    value: "assigned_to",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Actions",
                    align: "start",
                    sortable: false,
                    value: "actions",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
            ],
        };
    },
    methods: {
        ...mapActions("Screens", ["updateAssignedTo"]),
        getActions(item) {
            return lib
                .getActions(item)
                .filter((item) => this.can(item.permission));
        },
        updateAssigned(order_id, user) {
            this.updateAssignedTo({
                order_id,
                user_id: user.id,
            });
        },
        editable(status) {
            return ![
                "SCREEN_ERROR",
                "SCREEN_IN_PROCESS",
                "APPLICANT_SUBMITTED",
            ].includes(status);
        },
        editEnabled(status) {
            return this.editable(status);
        },
        actionDisabled(status) {
            return !this.editable(status) && this.cannot("orders.resubmit");
        },
        processing(status) {
            return ["SCREEN_IN_PROCESS"].includes(status);
        },
    },
};
</script>

<style scoped>
</style>